/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["format", "inputRef"];
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { microInputMixin } from '../input/internal/inputMixins';
import { fontsLoadedPromise } from '../utils/Fonts';
import { getDatePlaceholder } from '../utils/Locale';
import { getTextWidth } from '../utils/MeasureText';
import UIDateInput from './UIDateInput';
import { jsx as _jsx } from "react/jsx-runtime";
const DateInputWrapper = styled(UIDateInput).withConfig({
  displayName: "UIMicroDateInput__DateInputWrapper",
  componentId: "sc-1n0fbrz-0"
})(["display:inline-block;"]);
const MicroInput = styled(UIDateInput.defaultProps.Input).withConfig({
  displayName: "UIMicroDateInput__MicroInput",
  componentId: "sc-1n0fbrz-1"
})(["&&{", ";}"], microInputMixin);
const UIMicroDateInput = props => {
  const {
      format,
      inputRef
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const defaultInputRef = useRef(null);
  const computedInputRef = inputRef || defaultInputRef;
  const [measuredWidth, setMeasuredWidth] = useState(137);
  useEffect(() => {
    let isMounted = true;
    const measureInput = () => {
      setMeasuredWidth(Math.ceil(getTextWidth(computedInputRef.current, getDatePlaceholder(format))));
    };
    measureInput();
    fontsLoadedPromise.then(() => {
      if (isMounted) measureInput();
    });
    return () => {
      isMounted = false;
    };
  }, [format]); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/_jsx(DateInputWrapper, Object.assign({}, rest, {
    format: format,
    iconSize: 14,
    inputRef: computedInputRef,
    inputWidth: measuredWidth
  }));
};
UIMicroDateInput.propTypes = UIDateInput.propTypes;
UIMicroDateInput.defaultProps = Object.assign({}, UIDateInput.defaultProps, {
  Input: MicroInput
});
UIMicroDateInput.displayName = 'UIMicroDateInput';
export default UIMicroDateInput;